import { Form } from 'react-bootstrap';

import config from '../../../config';
import { InquiryItem } from '../../../models/Inquiry/Inquiry';

interface Props {
  data: InquiryItem
}

export default function InquiryPreviewItem({ data }: Props) {
  const renderInput = (type: number, id: string): JSX.Element | null => {
    switch (type) {
      case config.items.types.text.value:
        return <input type="text" className="form-control notranslate" translate="no" required={data?.required} maxLength={data?.max_length} placeholder={data?.placeholder} id={id} />;
      case config.items.types.number.value:
        return <input type="number" className="form-control notranslate" translate="no" required={data?.required} placeholder={data?.placeholder} id={id} />;
      case config.items.types.email.value:
        return <input type="email" className="form-control notranslate" translate="no" required={data?.required} placeholder={data?.placeholder} id={id} />;
      case config.items.types.textarea.value:
        return <textarea className="form-control notranslate" translate="no" required={data?.required} rows={4} maxLength={data?.max_length} placeholder={data?.placeholder} id={id} />;
      case config.items.types.date.value:
        return <input type="date" className="form-control notranslate" translate="no" required={data?.required} placeholder={data?.placeholder} id={id} />;
      case config.items.types.checkbox.value:
        return <input className="form-check-input" required={data?.required} type="checkbox" value="" id={id} />;
      case config.items.types.select.value:
        return (
          <select className="form-select" id={id}>
            {data?.options?.map((option, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <option value={option} key={i} translate="no" className="notranslate">{option}</option>
            ))}
          </select>
        );
      case config.items.types.map.value:
      case config.items.types.youtube.value:
        return <textarea className="form-control notranslate" translate="no" required={data?.required} placeholder={data?.placeholder} id={id} />;
      case config.items.types.image.value:
        return (
          <div className="d-flex flex-column">
            <input type="file" className="form-control" accept="image/*" required={data?.required} placeholder={data?.placeholder} id={id} />
          </div>
        );
      case config.items.types.radio.value:
        return (
          <div>
            {data.options?.map((option, index) => (
              <Form.Check
                inline
                id={`radio_${data.item_id}_${index}`}
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                label={<span translate="no" className="notranslate">{option}</span>}
                type="radio"
                value={option}
              />
            ))}
          </div>
        );
      case config.items.types.group.value:
        return (
          <>
            {
              data?.children?.map((child) => (
                <div className="card mb-0 w-100">
                  <div className="card-body">
                    <InquiryPreviewItem key={child.uuid} data={child} />
                  </div>
                </div>
              ))
            }
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="mb-3 row">
      <label className="col-sm-2 form-label d-flex align-items-center gap-2" htmlFor={`item_${data.item_id}`} style={{ height: 'fit-content' }}>
        <span className="fw-bold notranslate" translate="no">
          {data?.label}
        </span>

        {data?.required && (<span className="label-required">Required</span>)}
      </label>

      <div className="col-sm-10">
        <div className="d-flex flex-wrap flex-lg-nowrap align-items-center gap-2">
          {data?.prefix && <span translate="no" className="notranslate">{data?.prefix}</span>}
          {renderInput(data?.type, `item_${data.item_id}`)}
          {data?.suffix && <span translate="no" className="notranslate">{data?.suffix}</span>}
        </div>

        {data.max_length && (
          <div className="d-flex align-items-center gap-2">
            <div className="text-muted form-text">
              Character limit:
              {' '}
              {data.max_length}
            </div>
            <div className="text-muted form-text">Current characters: 0</div>
          </div>
        )}
      </div>
    </div>
  );
}
